module.exports = __webpack_public_path__ + "img/tzfardea_no.53d6cbc6.png";